import { useCallback } from "react";
import { ComissoesListSearchProps } from "../comissoes-tabs/comissoes-list-search-props";
import PesquisaComissoesPagas from "./pesquisa-comissoes/pesquisa-comissoes-pagas";

export interface ComissoesFilterProps {
    openPesquisa: boolean;
    setSearchProps: (props: ComissoesListSearchProps) => any;
    searchProps: ComissoesListSearchProps;
}

export const ComissoesPagasFilter = ({
    openPesquisa,
    setSearchProps,
    searchProps
}: ComissoesFilterProps) => {
    const onPesquisar = useCallback(
        (props: ComissoesListSearchProps) => {
            setSearchProps(props);
        },
        [setSearchProps]
    );

    return (
        <>
            {openPesquisa ? <PesquisaComissoesPagas onPesquisar={onPesquisar} searchProps={searchProps}
         onCloseSearch={() => {}} isOpened={openPesquisa} /> : null}
        </>
    );
};
